import React, { useState, useEffect, useRef } from "react";
import { Theme, FormControl } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import axios from "axios";
import { Modal } from "rsuite";
import _ from "lodash";
import { Helmet } from "react-helmet";
import MD5 from "js-md5";
import LangSelect from "../components/lang-select";
import { genUid } from "../utils/helper";
import Button from "../components/custom-button";
import FormInput from "../components/form-input";
import { globalStore, roomTypes } from "../stores/global";
import { useAuth } from "../services/auth-check";
import { t } from "../i18n";
import { roomStore } from "../stores/room";
import GlobalStorage from "../utils/custom-storage";
import Language from "@material-ui/icons/Language";

import { remoteConfig } from "../firebase";
import {
  API_COMMON_URL,
  API_V1_USERS,
  API_V1,
  AUTH_API,
} from "../services/ihr-meet-api";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    minWidth: "300px",
    maxWidth: "300px",
  },
}));

type SessionInfo = {
  roomName: string;
  roomType: number;
  yourName: string;
  role: string;
  email: string;
  password: string;
  forgetPasswordEmail: string;
  codePassword: string;
  room: string;
};

const defaultState: SessionInfo = {
  roomName: "",
  roomType: 2,
  role: "",
  yourName: "",
  email: "",
  password: "",
  forgetPasswordEmail: "",
  codePassword: "",
  room: "",
};

function LoginPage() {
  document.title = t(`home.short_title.title`);

  const classes = useStyles();
  const history = useHistory();
  const params = useParams<{ roomCode: string }>();
  const [countries, getCountriesData] = useState<any[]>([]);
  const [lang, setLang] = useState<string>("");

  if (params.roomCode) {
    localStorage.setItem(
      "roomLinkCode",
      `${JSON.stringify(params.roomCode ? params.roomCode : 0)}`
    );
  }

  useEffect(() => {
    const lang = GlobalStorage.getLanguage().language;

    const fetchData = async () => {
      const response = await axios.get(`${API_COMMON_URL}/countries`);
      getCountriesData(response.data.data);
    };
    fetchData();
    setLang(lang);
  }, []);

  const handleForgetPassword = () => {
    if (!session.forgetPasswordEmail) {
      setRequired({ ...required, forgetPasswordEmail: t("requiredField") });
      return;
    }
    const formData = {
      email: session.forgetPasswordEmail,
    };
    const lang =
      JSON.parse(localStorage.getItem("language") as string) === "en-US" ||
      JSON.parse(localStorage.getItem("language") as string) === "en"
        ? "en"
        : "ar";
    axios({
      method: "POST",
      headers: {
        "x-localization": lang,
      },
      url: `${API_V1}/reset-passwords/send-link`,
      data: formData,
    })
      .then(
        (response: any) => {
          session.forgetPasswordEmail = "";
          setAddCodeModalShow(false);
          globalStore.showToast({
            type: "msg",
            message: t("toast.emailSent"),
          });
        },
        (error: any) => {
          globalStore.showToast({
            type: "msg",
            message: t("toast.wrong_email", { reason: error.message }),
          });
          if (error.response.status == 404) {
            globalStore.showToast({
              type: "msg",
              message: error.response.data.message,
            });
          }
        }
      )
      .finally(() => {
        globalStore.stopLoading();
      });
  };

  const ref = useRef<boolean>(false);
  useEffect(() => {
    return () => {
      ref.current = true;
    };
  }, []);

  const [session, setSessionInfo] = useState<SessionInfo>(defaultState);

  const [codePasswordState, setPassword] = React.useState(false);

  const [required, setRequired] = useState<any>({} as any);
  const [addCodeModalShow, setAddCodeModalShow] = useState(false);

  const changelang = (lang: string) => {
    if (lang == "ar") {
      localStorage.setItem("language", `${JSON.stringify("ar")}`);
      document.documentElement.lang = "ar";
      globalStore.setLanguage("ar");
    } else {
      localStorage.setItem("language", `${JSON.stringify("en")}`);
      document.documentElement.lang = "en";
      globalStore.setLanguage("en");
    }
  };

  const handleSubmit = () => {
    if (!session.email || !session.password) {
      setRequired({ ...required, missingField: t("requiredField") });
      return;
    }

    const formData = {
      grant_type: "password",
      client_id: 6,
      username: session.email,
      password: session.password,
      client_secret: "E8zatcU2OQmbB0JJDZCJBX9o9rHrrndIHLQShWOx",
    };

    axios({
      method: "POST",
      url: `${AUTH_API}`,
      data: formData,
    })
      .then(
        (response: any) => {
          if (!response.data.is_blocked) {
            localStorage.setItem(
              "UserData",
              `${JSON.stringify(response.data)}`
            );
            localStorage.setItem(
              "accessToken",
              `${JSON.stringify(response.data.access_token)}`
            );
            axios
              .get(`${API_V1_USERS}/${response.data.user_id}`)
              .then((res) => {
                localStorage.setItem(
                  "UserFullData",
                  `${JSON.stringify(res.data.data)}`
                );
                let data = _.filter(countries, {
                  id: res.data.data.country_id,
                });
                localStorage.setItem(
                  "countryCode",
                  `${JSON.stringify(data[0] && data[0].country_code)}`
                );

                console.log(JSON.parse(localStorage.getItem("roomLinkCode") as string) > 0);

                if (
                  params.roomCode ||
                  JSON.parse(localStorage.getItem("roomLinkCode") as string) > 0
                ) {
                  const roomLinkCode = params.roomCode
                    ? params.roomCode
                    : JSON.parse(
                        localStorage.getItem("roomLinkCode") as string
                      );
                  axios
                    .get(`${API_COMMON_URL}/room-by-code/${roomLinkCode}`)
                    .then((codeRes) => {
                      if (codeRes.data.data.is_active_password) {
                        sessionStorage.setItem(
                          "LoginRoomData",
                          `${JSON.stringify(codeRes.data.data)}`
                        );
                        history.push(`/`);
                      } else {
                        checkRoom(codeRes.data.data, res.data.data);
                      }
                    })
                    .catch((error) => {
                      globalStore.showToast({
                        type: "rtmClient",
                        message: t("toast.wrongRoomName"),
                      });
                      localStorage.removeItem("roomLinkCode");
                      history.push(`/`);
                    });
                } else {
                  history.push(`/`);
                }
              });
          } else {
            globalStore.showToast({
              type: "rtmClient",
              message: t("toast.userBlocked"),
            });
          }
        },
        (error: any) => {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.wrong_email_or_password", {
              reason: error.message,
            }),
          });
        }
      )
      .finally(() => {
        globalStore.stopLoading();
      });
  };

  const checkRoom = (data: any, UserData: any) => {
    if ((data && data.is_active) || (data && data.expired_date === "null")) {
      let currentDate = new Date();
      let date = data.expired_date ? new Date(data.expired_date) : "nullable";
      if (date >= currentDate || date === "nullable") {
        // localStorage.setItem("RoomData", `${JSON.stringify(data)}`);
        handleLogin(data, UserData);
      } else {
        globalStore.showToast({
          type: "error",
          message: t("toast.room_not-working"),
        });
        history.push("/");
      }
    } else {
      globalStore.showToast({
        type: "error",
        message: t("toast.inActiveRoom"),
      });
      history.push("/");
    }
  };

  const handleLogin = (data: any, UserData: any) => {
    session.roomType = data.room_type_id;
    session.roomName = data.code;

    //   session.roomName = codeRes.data.data.code;
    // session.roomType = data.room_type_id;
    if (!roomTypes[session.roomType]) return;
    const path = roomTypes[session.roomType].path;
    const payload = {
      uid: genUid(),
      rid: `${session.roomType}${MD5(data.code)}`,
      role: "student",
      roomName: params.roomCode
        ? params.roomCode
        : JSON.stringify(localStorage.getItem("roomLinkCode")),
      roomType: data.room_type_id,
      video: 0,
      audio: 1,
      chat: 1,
      account: UserData.name,
      rtmToken: "",
      boardId: "",
      linkId: 0,
      sharedId: 0,
      lockBoard: 0,
      grantBoard: 0,
    };
    ref.current = true;
    globalStore.showLoading();
    roomStore
      .loginAndJoin(payload)
      .then(() => {
        history.push(`/classroom/${path}`);
      })
      .catch((err: any) => {
        if (err.reason) {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.rtm_login_failed_reason", { reason: err.reason }),
          });
        } else {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.rtm_login_failed"),
          });
        }
        console.warn(err);
      })
      .finally(() => {
        ref.current = false;
        globalStore.stopLoading();
      });
  };

  const handleCodePassword = () => {
    const roomData = JSON.parse(localStorage.getItem("RoomData") as string);
    if (!session.codePassword) {
      setRequired({ ...required, codePassword: t("home.missingPassword") });
      return;
    }
  };

  const [authorized, redirect] = useAuth("LOGIN");

  if (!authorized) {
    redirect();
    return null;
  }

  return (
    <div className="bg-main">
      <Helmet>
        <title>Login</title>
        <meta name="description" content="Some description." />
        <meta
          name="apple-itunes-app"
          content={`app-id=1504008986, app-argument=https://stg.ihrmeet.com/#/room/${
            params && params.roomCode
          }`}
        />
      </Helmet>
      <div className={`setting-container-login`}>
        {lang == "ar" ? (
          <button className="lang-btn" onClick={() => changelang("en")}>
            <span>English</span>
            <Language />
          </button>
        ) : (
          <button className="lang-btn" onClick={() => changelang("ar")}>
            <span>عربي</span> <Language />
          </button>
        )}
      </div>
      <div
        className={`flex-container home-cover-web ${JSON.parse(
          localStorage.getItem("language") as string
        )}`}
      >
        <div className="center-column">
          <div className="logo"></div>
          <div className="ihr-meet">iHR Meet</div>
          <div className="position-content flex-direction-column">
            <FormControl className={classes.formControl}>
              <FormInput
                placeholder={t("email")}
                value={session.email}
                onChange={(val: string) => {
                  setSessionInfo({
                    ...session,
                    email: val,
                  });
                }}
                type="email"
                requiredText={session.email ? "" : required.missingField}
                loginRequired={true}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <FormInput
                placeholder={t("password")}
                value={session.password}
                onChange={(val: string) => {
                  setSessionInfo({
                    ...session,
                    password: val,
                  });
                }}
                type="password"
                requiredText={session.password ? "" : required.missingField}
                loginRequired={true}
              />
            </FormControl>
            <div className="forget-password ">
              <Button
                className="forget-password-butt"
                name={t("forgetPassword")}
                onClick={() => {
                  setAddCodeModalShow(true);
                }}
              />
            </div>
            <Button name={t("signIn")} onClick={handleSubmit} />
            <div style={{ margin: "-12px" }}>
              <div className=" action">
                <Button
                  className="register-butt"
                  name={t("register")}
                  onClick={() => {
                    history.push("/register");
                  }}
                />
              </div>
            </div>
            <div className="mobile-buttons">
              <a href="https://play.google.com/store/apps/details?id=com.sto.ihrmeet">
                <div className="google-play"></div>
              </a>
              <a href="https://apps.apple.com/app/id1504008986">
                <div className="app-store"></div>
              </a>
            </div>
            <div className="social-buttons">
              <a
                href="https://www.facebook.com/IHRJOBS"
                className="facebook"
              ></a>
              <a
                href={`https://twitter.com/ihrjobs?lang=${lang}`}
                className="twitter"
              ></a>
            </div>
            <div className="POWERED-BY">POWERED BY</div>
            <div className="ihr-logo"></div>
          </div>
        </div>

        <Modal
          show={addCodeModalShow}
          dialogClassName={`change-password-modal ${JSON.parse(
            localStorage.getItem("language") as string
          )}`}
          backdropClassName={"backdrop-change-password-modal"}
          onHide={() => {
            setAddCodeModalShow(false);
          }}
          backdrop
          size={"sm"}
        >
          <Modal.Header />
          <Modal.Body>
            <div className="change-password">
              <h5>{t("forgetPassword")}</h5>
              <FormControl className={classes.formControl}>
                <FormInput
                  placeholder={t("email")}
                  value={session.forgetPasswordEmail}
                  onChange={(val: string) => {
                    setSessionInfo({
                      ...session,
                      forgetPasswordEmail: val,
                    });
                  }}
                  type="email"
                  requiredText={required.forgetPasswordEmail}
                />
              </FormControl>
              <Button name={t("send")} onClick={handleForgetPassword} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <span
              style={{ cursor: "pointer", color: "#ffff" }}
              onClick={() => {
                setAddCodeModalShow(false);
              }}
            >
              {t("toast.cancel")}
            </span>
          </Modal.Footer>
        </Modal>

        <Modal
          show={codePasswordState}
          dialogClassName={`change-password-modal ${JSON.parse(
            localStorage.getItem("language") as string
          )}`}
          backdropClassName={"backdrop-change-password-modal"}
          onHide={() => {
            setPassword(false);
          }}
          backdrop
          size={"sm"}
        >
          <Modal.Header />
          <Modal.Body>
            <div className="change-password">
              <h5>{t("roomPassword")}</h5>
              <FormControl className={classes.formControl}>
                <FormInput
                  placeholder={t("password")}
                  value={session.codePassword}
                  onChange={(val: string) => {
                    setSessionInfo({
                      ...session,
                      codePassword: val,
                    });
                  }}
                  type="password"
                  requiredText={required.codePassword}
                />
              </FormControl>
              <Button name={t("submit")} onClick={handleCodePassword} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
      <div
        className={`mobile ${JSON.parse(
          localStorage.getItem("language") as string
        )}`}
      >
        <div className="logo"></div>
        <div className="ihr-meet">iHR Meet</div>
        <p style={{ color: "white" }}>{t("mobileMsg")}</p>
        <div className="butts">
          <a
            href="https://apps.apple.com/app/id1504008986"
            className="app-store"
          ></a>
          <a
            href="https://play.google.com/store/apps/details?id=com.sto.ihrmeet"
            className="google-play"
          ></a>
        </div>
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="POWERED-BY">POWERED BY</div>
          <div className="ihr-logo"></div>
        </div>
      </div>
    </div>
  );
}
export default React.memo(LoginPage);
